import DatePicker from 'react-datepicker'
import moment from 'moment'
import classNames from 'classnames'
import FormControlWrapper from '../FormControlWrapper'

const formatValueToState = value => value.utc().format('YYYY-MM-DDTHH:mm:ss[Z]')

const Input = props => (
  <FormControlWrapper
    name={props.name}
    label={props.label}
    required={props.required}
    horizontal={props.horizontal}
    error={props.formComponent ? (props.touched ? props.error : '') : props.error}
    help={props.help}
    icon={props.icon}
    size={props.size}
    disabled={props.disabled}
  >
    <DatePicker
      {...props}
      autoComplete='off'
      className={classNames({
        'input': true,
        'is-static': props.isStatic,
        [`is-${props.size}`]: props.size,
        [props.className]: props.className
      })}
      selected={props.selected ? moment(props.selected) : null}
      onChange={value => props.handleChange(formatValueToState(value))} />
  </FormControlWrapper>
)

Input.defaultProps = {
  size: 'small',
}

export default Input



// WEBPACK FOOTER //
// ./components/uiLib/DatePicker/DatePicker.js